import RelatedDocumentsBodyNavContentCollapsible from './RelatedDocumentsBodyNavContentCollapsible'

export default RelatedDocumentsBodyNavContentCollapsible



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavContentCollapsible/index.js